import { render } from "./CampaignsListPage.vue?vue&type=template&id=68ef4880&scoped=true"
import script from "./CampaignsListPage.vue?vue&type=script&lang=js"
export * from "./CampaignsListPage.vue?vue&type=script&lang=js"

import "./CampaignsListPage.vue?vue&type=style&index=0&id=68ef4880&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ef4880"]])

export default __exports__